import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import { grey } from '@mui/material/colors';
import React from 'react';

export const CustomBoxCard = ({ ...props }) => (
    <Box
        {...props}
        sx={{
            border: `1px solid ${grey[300]}`,
            marginBottom: '0.5rem',
            borderRadius: '0.5rem',
            padding: '0.4rem',
            paddingBottom: '0.2rem',
        }}
    />
);

export const CustomAlert = ({ ...props }) => (
    <Alert
        {...props}
        sx={{
            padding: '0.2rem 0.2rem 0.2rem 0.5rem',
            color: grey[900],
            borderRadius: '0.5rem',
            '& div': { width: '100%', display: 'flex' },
        }}
    />
);
